/*
 * zl-stand: Der Stand einer Laborseite steht in der Adresse, nach dem #, als Name=Wert mit & getrennt (#r=5&schleier=0.14).
 * So ist jeder Zustand ein Link, den man vergleichen, schicken und später wieder öffnen kann.
 *
 * window.zlStand.lesen(START): liest die Werte aus der Adresse. Typ je Feld wie in START (Zahl, Wahrheitswert, Text).
 *   #r5 (alte Form) gilt wie #r=5.
 * window.zlStand.schreiben(S, START): schreibt nur die Felder in die Adresse, die von START abweichen, r immer zuerst.
 *   Felder mit Objekten als Wert bleiben außen vor. Ohne Abweichung steht nichts nach dem #.
 * window.zlStand.link(): die vollständige Adresse des aktuellen Stands.
 *
 * Ein Labor liest nach dem Zusammenbau seiner Werte: Object.assign(S, zlStand.lesen(START)),
 * und ruft in seiner Speicherfunktion zlStand.schreiben(S, START). Mehr braucht es nicht.
 */
(() => {
  const alteForm = /^#r(\d+)$/;
  function lesen(START) {
    const roh = location.hash;
    const stand = {};
    if (!roh || roh.length < 2) return stand;
    const alt = roh.match(alteForm);
    if (alt) { stand.r = alt[1]; return stand; }
    roh.slice(1).split('&').forEach((paar) => {
      if (!paar) return;
      const i = paar.indexOf('=');
      if (i < 1) return;
      const k = decodeURIComponent(paar.slice(0, i));
      const v = decodeURIComponent(paar.slice(i + 1));
      if (!START || !(k in START)) return;
      const vorlage = START[k];
      if (typeof vorlage === 'object' && vorlage !== null) return;
      if (typeof vorlage === 'number') { const z = Number(v); if (!Number.isNaN(z)) stand[k] = z; return; }
      if (typeof vorlage === 'boolean') { stand[k] = v === 'true' || v === 'an' || v === '1'; return; }
      stand[k] = v;
    });
    return stand;
  }
  function schreiben(S, START) {
    if (!S) return;
    const teile = [];
    const dazu = (k) => {
      const v = S[k];
      if (typeof v === 'object' && v !== null) return;
      if (START && k in START && String(START[k]) === String(v)) return;
      if (k === 'v') return;
      teile.push(encodeURIComponent(k) + '=' + encodeURIComponent(String(v)));
    };
    if ('r' in S) dazu('r');
    Object.keys(S).filter((k) => k !== 'r').sort().forEach(dazu);
    const neu = teile.length ? '#' + teile.join('&') : '';
    if (neu === location.hash || (!neu && !location.hash)) return;
    history.replaceState(null, '', location.pathname + location.search + neu);
  }
  function link() { return location.href; }
  window.zlStand = { lesen, schreiben, link };
})();
